import React from 'react'

import { ModelCard, Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string } from 'prop-types'


import i18n from 'Pods/Shared/I18n'

function CouponCard({ title, description, imgSrc, url, code = '' }) {
  return (
    <ModelCard customClass="coupon-card">
      <img src={imgSrc} alt={title} className="coupon-card__image" />

      <div className="coupon-card__notice">
        {i18n.t('coupons.deal', { ns: 'rails' })}
      </div>

      <h2 className="cgt-legacy-heading-h2 coupon-card__title">{title}</h2>

      {description && (
        <div className="coupon-card__description cgt-mb-20">{description}</div>
      )}

      {code && (
        <div className="coupon-card__code cgt-mb-20">
          {i18n.t('coupons.useCode', { ns: 'rails' })} {code}
        </div>
      )}

      <Button
        type="primary"
        onClick={() => (window.location.href = url)}
        customClass="coupon-card__button"
        expand
      >
        {i18n.t('coupons.getDeal', { ns: 'rails' })}
      </Button>
    </ModelCard>
  )
}

CouponCard.propTypes = {
  title: string.isRequired,
  description: string.isRequired,
  imgSrc: string.isRequired,
  url: string.isRequired,
  code: string,
}

export default CouponCard
